export default "__VITE_ASSET__IFRjviZd__"